export const calculateTotalRevenue = (bookings) =>
  bookings.reduce((sum, booking) => sum + booking.totalamount, 0);
